export enum SteamStatuses {
    NORMAL='normal',
    DELAYED='delayed',
    SURGE='surge',
    OFFLINE='offline'
}
